var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-embed"},[_c('div',{class:[
      'v-embed__wrapper',
      _vm.aspect && ("v-embed__wrapper--aspect-" + _vm.aspect)
    ]},[_vm._t("default")],2),(!!_vm.description)?_c('v-text',{staticClass:"text-gray-dark my-3"},[_vm._v("\n    "+_vm._s(_vm.description)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }